import { getTaxRateShippingUtil } from 'modules/shipping/utils/get-tax-rate'
import { getObjectUtil } from 'packages/src'

/**
 * Gets the estimated tax for the given address.
 * @param  {number} subTotal
 * @param  {Address} address
 * @returns {number}
 */
function getTaxCartUtil (subTotal, address) {
  const country = (
    getObjectUtil(address, 'changed.country') ||
    getObjectUtil(address, 'data.country')
  )
  const state = (
    getObjectUtil(address, 'changed.state') ||
    getObjectUtil(address, 'data.state')
  )
  const taxRate = getTaxRateShippingUtil(country, state)
  // If there is no tax rate, noop
  if (!taxRate) {
    return taxRate
  }
  return parseFloat((subTotal * taxRate).toFixed(2))
}

/**
 * Gets the displayable text content.
 * @param  {Notification} notification
 * @param  {Instance[]} associatedInstances
 * @returns {Object}
 */
function getNotificationCartUtil (notification, associatedInstances) {
  const products = notification.data.products
  const productPointer = products[0]
  const product = associatedInstances.find(
    a => a.data.id === productPointer.data.id
  )
  const {
    img,
    name
  } = product.data
  const image = img
  let textPrefix
  let text
  let textBold = name
  if (products.length > 1) {
    const otherLength = products.length - 1
    if (otherLength > 1) {
      textBold += ` and ${otherLength} other products`
    } else {
      textBold += ' and 1 other product'
    }
    text = 'were'
  } else if (notification.data.count > 1) {
    textPrefix = notification.data.count
    text = 'were'
  } else {
    textPrefix = 'A'
    text = 'was'
  }
  text += ' added to your cart'
  const imageUrl = '/cart'
  const textUrl = '/cart'
  return {
    image,
    imageUrl,
    text,
    textBold,
    textPrefix,
    textUrl
  }
}

export {
  getNotificationCartUtil,
  getTaxCartUtil
}
